//主页面功能管理
//import home from '../../views/home.vue'

// const index = r => require.ensure([], () => r(require('../../views/index.vue')), 'example');

// const home = r => require.ensure([], () => r(require('../../views/home.vue')), 'example');

// const contractmanagement = r => require.ensure([], () => r(require('../../views/contract/contractManagement.vue')), 'example');

export default [
	// {
	// path: '/',
	// redirect: '/index',
	// // component: Home
	// },
	{
		//path: '/home',
		//name: 'home',
		path: '/index',
		name: 'index',
		redirect: '',
		meta: {
			index: 1,
			keepAlive: true,
		},
		component: () => import('../../views/index.vue'),
		//component:index,
		children: [{
			path: '/home',
			name: 'home',
			meta: {
				index: 2,
				keepAlive: true,
			},
			component: () => import('../../views/home.vue'),
		}, {
			path: '/contractmanagement',
			name: 'contractmanagement',
			meta: {
				index: 2,
				keepAlive: true,
			},
			component: () => import('../../views/contract/contractManagement.vue'),
		}, {
			path: '/enterpriselist',
			name: 'enterpriselist',
			meta: {
				index: 2,
				keepAlive: false,
			},
			component: () => import('../../views/enterprise/enterpriseList.vue'),
		}, {
			path: '/user',
			name: 'user',
			meta: {
				index: 2,
				keepAlive: false,
			},
			component: () => import('../../views/user/user.vue'),
		}, ]
	},

	{
		path: '/zhlh/index',
		name: 'zhlhIndex',
		redirect: '',
		meta: {
			index: 1,
			keepAlive: true,
		},
		component: () => import('../../views/zhlh/index.vue'),
		children: [{
			path: '/zhlh/home',
			name: 'zhlhHome',
			meta: {
				index: 2,
				keepAlive: true,
			},
			component: () => import('../../views/zhlh/home.vue'),
		}, {
			path: '/zhlh/user',
			name: 'zhlhUser',
			meta: {
				index: 2,
				keepAlive: true,
			},
			component: () => import('../../views/zhlh/user.vue'),
		}, ]
	},


	// 节能减碳页
	{
		path: '/energyconservationcorplist',
		name: 'energyconservationcorplist',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/energyConservationCorpList.vue'),
	},

	// 节能减碳页明细
	{
		path: '/energyconservationcorplistdetails',
		name: 'energyconservationcorplistdetails',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/energyConservationCorpListDetails.vue'),
	},

	// 存证查验页
	{
		path: '/certificateverification',
		name: 'certificateverification',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/certificateVerification.vue'),
	},

	// 查验详情页
	{
		path: '/verifdetails',
		name: 'verifdetails',
		meta: {
			index: 5,
			keepAlive: false,
		},
		component: () => import('../../views/tools/verifDetails.vue')
	},


	//消息/公告列表页
	{
		path: '/newsList',
		name: 'newslist',
		meta: {
			index: 3,
			keepAlive: true,
		},
		component: () => import('../../views/news/newsList.vue')
	},
	//消息/公告详情页
	{
		path: '/newsDetails',
		name: 'newsDetails',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/news/newsDetails.vue')
	},
	//推介消息详情页
	{
		path: '/guidedetails',
		name: 'guidedetails',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/guideDetails.vue')
	},
	//二维码
	{
		path: '/scancode',
		name: 'scancode',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/scanCode.vue')
	},
	//扫码
	{
		path: '/codesign',
		name: 'codesign',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/codeSign.vue')
	},


	// 证书列表页面
	{
		path: '/faceauth',
		name: 'faceauth',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/tools/faceAuth.vue')
	},

	// 证书列表页面
	{
		path: '/certlist',
		name: 'certlist',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/certList.vue')
	},

	// 证书详情页面
	{
		path: '/certdetails',
		name: 'certdetails',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/certDetails.vue')
	},

	//各种协议详情页
	{
		path: '/agreementdetails',
		name: 'agreementdetails',
		meta: {
			index: 4,
			keepAlive: false,
		},
		component: () => import('../../views/tools/agreementDetails.vue')
	},
	// 证书申请页
	{
		path: '/corpCertApply',
		name: 'corpCertApply',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/corpCertApply.vue')
	},
// 证书申请 结果页
	{
		path: '/corpCertApplySuccess',
		name: 'corpCertApplySuccess',
		meta: {
			index: 3,
			keepAlive: false,
		},
		component: () => import('../../views/signetcert/corpCertApplySuccess.vue')
	},

]
